export default function FAQuestion (props:any){
    return <div className="relative text-left mx-auto w-full">{props.children}</div>
}